/**
 * useDebouncedValue
 *
 * Small shared debounce helper used across the list primitives (search box, text/number
 * column filters, adaptive-grid search) so the 300ms debounce window in the List & Grid
 * Standard is defined once instead of re-implemented per hook.
 */
import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
